import { useTheme } from "../hooks/useTheme";
import { useLocale } from "../hooks/useLocale";

/**
 * Theme toggle control — switches between light and dark modes.
 * Uses aria-pressed to communicate current state to assistive technologies.
 * Accessible via keyboard (Enter/Space) with ARIA label.
 */
export function ThemeSwitcher() {
  const { theme, toggleTheme } = useTheme();
  const { t } = useLocale();

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="theme-switcher"
      onClick={toggleTheme}
      aria-label={t("aria.themeSwitcher")}
      aria-pressed={isDark}
    >
      <span className="theme-icon" aria-hidden="true">
        {isDark ? "☀️" : "🌙"}
      </span>
    </button>
  );
}
